import { IconStar } from './IconStar';
import styles from './ReviewsStarsRating.module.scss';

interface ReviewsStarsRatingProps {
    readonly rating: number;
    readonly iconSize?: number;
}

const ReviewsStarsRating = ({ iconSize, rating }: ReviewsStarsRatingProps): JSX.Element => {
    const iconsFill = [];

    for (let i = 0; i < 5; i++) {
        if (rating >= i + 1) {
            iconsFill.push({ selected: true, isHalf: false });
        } else if (rating > i && rating < i + 1) {
            iconsFill.push({ selected: true, isHalf: true });
        } else {
            iconsFill.push({ selected: false, isHalf: false });
        }
    }

    return (
        <div className={styles.container}>
            {iconsFill.map(icon => (
                <IconStar
                    key={`${icon.selected}-${icon.isHalf}`}
                    size={iconSize}
                    selected={icon.selected}
                    isHalf={icon.isHalf}
                />
            ))}
        </div>
    );
};

export { ReviewsStarsRating };
